import Typography from "@material-ui/core/Typography";
import React, { FC, useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { Stripe, loadStripe } from "@stripe/stripe-js";
import { useHistory, useLocation, useParams } from "react-router-dom";

import AddPaymentMethodModal from "./AddPaymentMethodModal";
import Button from "../../../../../components/elements/Button";
import Loader from "../../../../../components/elements/Loader";
import classes from "../../AdvertiserDetailsSection.module.scss";
import creditCardIcon from "../../../../../assets/icons/CreditCardIcon.svg";
import { AdvertiserType } from "../../../../../types/advertiserTypes";
import { toTitleCase } from "../../../../../helpers/toTitleCase";

type CreditCardConnectorProps = {
  advertiser: AdvertiserType;
  fetchAndSetAdvertiserDetailData: () => void;
};

const CreditCardConnector: FC<CreditCardConnectorProps> = ({ advertiser, fetchAndSetAdvertiserDetailData }) => {
  const { paymentMethod } = advertiser;

  const [loadedStripeInstance, setLoadedStripeInstance] = useState<Stripe | null>(null);
  const [isAddPaymentMethodModalOpen, setIsAddPaymentMethodModalOpen] = useState(false);

  const history = useHistory();
  const location = useLocation();
  const params: { id: string } = useParams();

  const handleOpenAddPaymentMethodModal = () => {
    setIsAddPaymentMethodModalOpen(true);
  };

  const handleCloseAddPaymentMethodModal = () => {
    setIsAddPaymentMethodModalOpen(false);
  };

  const navigateToInvoicesPage = () => {
    history.push(`/invoices?advertiser=${params.id}`, { from: location.pathname });
  };

  useEffect(() => {
    const loadStripeInstance = async () => {
      try {
        const stripeInstance = await loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!);
        setLoadedStripeInstance(stripeInstance);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log("error loadStripeInstance: ", error);
      }
    };
    loadStripeInstance();
  }, []);

  return (
    <div className={classes.creditCardConnector}>
      <div className={classes.status}>
        <img src={creditCardIcon} alt="credit card icon" />

        <div className={classes.statusTextContainer}>
          {paymentMethod ? (
            <Typography className={classes.connected}>
              * * * * {paymentMethod.card.last4} ({toTitleCase(paymentMethod.card.brand)})
            </Typography>
          ) : (
            <Typography className={classes.notConnected}>No Card</Typography>
          )}
          <Typography className={classes.title}>Current Selected Card</Typography>
        </div>

        {advertiser.advertiser_card_name ? (
          <div className={classes.cardFriendlyNameContainer}>
            <Typography>Card Friendly Name:</Typography>
            <Typography>{advertiser.advertiser_card_name}</Typography>
          </div>
        ) : null}
      </div>

      <div className={classes.controls}>
        <Button variant="outlined" onClick={handleOpenAddPaymentMethodModal}>
          {paymentMethod ? "Edit" : "Add"} Payment Method
        </Button>
        <Button variant="outlined" onClick={navigateToInvoicesPage}>
          Invoices
        </Button>

        {loadedStripeInstance === null ? (
          <Loader isAbsolutePosition={false} size={36} />
        ) : (
          <Elements stripe={loadedStripeInstance}>
            <AddPaymentMethodModal
              isOpen={isAddPaymentMethodModalOpen}
              handleClose={handleCloseAddPaymentMethodModal}
              advertiserId={advertiser.brandgenAdvertiserId}
              fetchAndSetAdvertiserDetailData={fetchAndSetAdvertiserDetailData}
            />
          </Elements>
        )}
      </div>
    </div>
  );
};

export default CreditCardConnector;
